import React, { useState } from 'react';
import { AuthLayout } from '../layouts/AuthLayout';
import { AuthInput } from '../components/AuthInput';
import { AuthButton } from '../components/AuthButton';
import { Link, useNavigate } from 'react-router-dom';
import { authService, LoginPayload } from '../services/authService';
import { message } from 'antd';
import { STORAGE_KEYS } from '@/config/app.config';
import { useTenant } from '@/features/tenant/context/TenantContext';

export const LoginPage: React.FC = () => {
    const navigate = useNavigate();
    const { tenantCode } = useTenant();
    const [loading, setLoading] = useState(false);
    const [formData, setFormData] = useState<LoginPayload>({
        email: '',
        password: ''
    });

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        setLoading(true);
        try {
            const response = await authService.login(formData);
            if (response.success && response.data) {
                const { token, user } = response.data;
                message.success("Login successful!");
                // Store token and user info
                localStorage.setItem(STORAGE_KEYS.ACCESS_TOKEN, token);
                if (user) {
                    localStorage.setItem(STORAGE_KEYS.USER_INFO, JSON.stringify(user));
                }
                navigate('/');
            }
        } catch (error: any) {
            const msg = error.response?.data?.error || error.message || "Login failed";
            message.error(msg);
        } finally {
            setLoading(false);
        }
    };

    return (
        <AuthLayout
            title="US Link CN"
            subtitle="美私专属管理"
        >
            <form onSubmit={handleSubmit}>
                <AuthInput
                    name="email"
                    type="email"
                    placeholder="Email"
                    label="Email"
                    autoFocus
                    value={formData.email}
                    onChange={handleChange}
                    required
                />
                <AuthInput
                    name="password"
                    type="password"
                    placeholder="Password"
                    label="Password"
                    value={formData.password}
                    onChange={handleChange}
                    required
                />

                <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '-1rem', marginBottom: '1rem' }}>
                    {/* <a href="#" style={{ color: 'var(--auth-accent-primary)', fontSize: '0.9rem', textDecoration: 'none' }}>
                        Forgot Password?
                    </a> */}
                </div>

                <AuthButton type="submit" loading={loading}>
                    登 录
                </AuthButton>
            </form>

            <div style={{ textAlign: 'center', marginTop: '1rem', color: 'var(--auth-text-secondary)' }}>
                没有账号？{' '}
                <Link to={`/${tenantCode}/register`} style={{ color: 'var(--auth-accent-secondary)', textDecoration: 'none', fontWeight: 600 }}>
                    注册
                </Link>
            </div>
        </AuthLayout>
    );
};
